import React from 'react'

function TrainingPage() {
  return (
    <div>TrainingPage</div>
  )
}

export default TrainingPage